export enum SigningOrderStatusEnum {
    FINISHED_SIGNING = 'ferdig_signert',
    CANCELLED = 'kansellert',
    READY_FOR_CANCELLATION = 'klar_for_kansellering',
    EXPIRED = 'utløpt',
    REJECTED = 'avvist',
    READY_FOR_SIGNING = 'klar_for_signering',
    PARTIALLY_SIGNED = 'delvis_signert',
}
